import {
  usePharmaCompanyOptions,
  useUserOptions,
} from '@/entities/filter/hooks/useFilterOptions';
import { orDash } from '@/shared/lib/format';
import { FilterGroup } from '@/shared/ui';

/**
 * 필터 드로어 섹션 (06 거래처 정보 · 07 처방 등록 현황) — 다중 선택.
 * value: undefined = 전체, [] = 아무것도 고르지 않음(적용 시 전체로 본다).
 */
interface IdListFilterProps {
  value: number[] | undefined;
  onChange: (ids: number[] | undefined) => void;
}

const toIds = (values: string[] | undefined) => values?.map(Number);

/** 담당자 — 05 업체 목록과 같은 집합 */
export function UserFilterGroup({ value, onChange }: IdListFilterProps) {
  const { data = [], isPending } = useUserOptions();
  return (
    <FilterGroup
      title="담당자"
      isLoading={isPending}
      value={value?.map(String)}
      options={data.map((user) => ({
        value: String(user.userId),
        label: `${orDash(user.companyName)}(${orDash(user.representativeName)})`,
      }))}
      onChange={(next) => onChange(toIds(next))}
    />
  );
}

export function PharmaCompanyFilterGroup({
  value,
  onChange,
}: IdListFilterProps) {
  const { data = [], isPending } = usePharmaCompanyOptions();
  return (
    <FilterGroup
      title="제약사"
      isLoading={isPending}
      value={value?.map(String)}
      options={data.map((company) => ({
        value: String(company.pharmaCompanyId),
        label: String(orDash(company.pharmaCompanyName)),
      }))}
      onChange={(next) => onChange(toIds(next))}
    />
  );
}
